import React, { useRef, useState } from 'react';

import { PulseLoader } from 'react-spinners';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

import LoadingScreen from 'src/components/LoadingScreen';
import { ModelOfVehicleItem } from 'src/database';

import { useListVehiclesController } from 'src/controllers/Vehicle/ListVehiclesController';
import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import { useData } from 'src/contexts/data';

const VehiclesListMovimentation: React.FC = () => {
	const [globalFilter, setGlobalFilter] = useState<string | null>(null);
	const { handleVehicleSelected } = useData();

	const { getListController, handleListController } = useListVehiclesController();

	const status = [
		{ label: 'Em manutenção', value: 0 },
		{ label: 'Pronto para uso', value: 1 },
	];

	if (getListController.loading) {
		return <LoadingScreen />;
	}

	const actionBodyTemplate = (vehicle: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-chevron-circle-right'
					className='p-button-rounded p-button-text p-button-success'
					onClick={() => {
						handleVehicleSelected(vehicle);
					}}
				/>
			</React.Fragment>
		);
	};

	const tableHeader = (
		<div className='table-header'>
			<div className='p-grid p-d-flex p-jc-between p-p-2'>
				<h5 className='p-m-0'>Veículos</h5>
				<span className='p-input-icon-left p-search-bar'>
					<i className='pi pi-search' />
					<InputText
						type='search'
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
						placeholder='Buscar...'
					/>
				</span>
			</div>
			<span>Selecione abaixo o veículo que deseja ver as movimentações</span>
		</div>
	);

	const HEADER_PLACA = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>PLACA</span>
				{rowData.PLACA}
			</React.Fragment>
		);
	};

	const HEADER_DESCRICAO = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>DESCRIÇÃO</span>
				{rowData.DESCRICAO}
			</React.Fragment>
		);
	};

	const HEADER_RENAVAM = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>RENAVAM</span>
				{rowData.RENAVAM}
			</React.Fragment>
		);
	};

	const HEADER_TIPOCOMBUSTIVEL = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>COMBUSTIVEL</span>
				{rowData.TIPOCOMBUSTIVEL?.DESCRICAO}
			</React.Fragment>
		);
	};

	const HEADER_STATUS = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>STATUS</span>
				{
					status.find(statusItem => {
						return statusItem.value === rowData.STATUS;
					})?.label
				}
			</React.Fragment>
		);
	};

	const HEADER_ESTOQUE = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>ESTOQUE</span>
				{rowData.NOME_ESTOQUE}
			</React.Fragment>
		);
	};

	const HEADER_UNIDADE = (rowData: ModelOfVehicleItem) => {
		return (
			<React.Fragment>
				<span className='left-header'>UNIDADE</span>
				{rowData.NOME_ORGAOUNIDADE}
			</React.Fragment>
		);
	};

	// const Loader: React.FC = ({ children }) => {
	// 	const divRef: any = useRef<HTMLDivElement | null>(null);

	// 	const [isVisible] = useIntersectionObserver({
	// 		elementRef: divRef,
	// 	});

	// 	if (isVisible && !getListController.maxData && !getListController.loadingRows) {
	// 		handleListController.setRows(getListController.rows + 20);
	// 	}

	// 	return (
	// 		<div
	// 			ref={divRef}
	// 			style={{
	// 				height: 'auto',
	// 				display: 'flex',
	// 				alignItems: 'center',
	// 				justifyContent: 'center',
	// 			}}>
	// 			{children}
	// 		</div>
	// 	);
	// };

	return (
		<div className='p-card p-p-4 datatable-container'>
			<Toast ref={getListController.toast} />

			<DataTable
				dataKey='ID'
				value={getListController.vehiclesData}
				header={tableHeader}
				rowHover
				globalFilter={globalFilter}
				autoLayout
				className='responsive-table p-datatable-sm'
				scrollable
				scrollHeight='100%'>
				<Column field='PLACA' header='PLACA' body={HEADER_PLACA}></Column>
				<Column field='DESCRICAO' header='DESCRIÇÃO' body={HEADER_DESCRICAO}></Column>
				<Column field='RENAVAM' header='RENAVAM' body={HEADER_RENAVAM}></Column>
				<Column field='FT_TIPOCOMBUSTIVEL' header='COMBUSTIVEL' body={HEADER_TIPOCOMBUSTIVEL}></Column>
				<Column field='STATUS' header='STATUS' body={HEADER_STATUS}></Column>
				<Column field='NOME_ESTOQUE' header='ESTOQUE' body={HEADER_ESTOQUE}></Column>
				<Column field='NOME_ORGAOUNIDADE' header='UNIDADE' body={HEADER_UNIDADE}></Column>
				<Column header='MOVIMENTAÇÕES' body={actionBodyTemplate} bodyStyle={{ textAlign: 'center' }}></Column>
			</DataTable>
			{/* <Loader>
				{!getListController.maxData ? (
					getListController.loadingRows ? (
						<PulseLoader color='#0388e5' size={8} />
					) : (
						<></>
					)
				) : (
					'Lista completa'
				)}
			</Loader> */}
		</div>
	);
};

export default VehiclesListMovimentation;
